import {analyticsEvents, getTrackerEvents} from './analyticsEvents';
import {__STAGING__, __DEBUG__} from '~/utils/env';

const logEventTrackingInfo = message => {
  if (__DEBUG__ || __STAGING__) {
    // eslint-disable-next-line no-console
    console.log('TRACK ANALYTICS EVENT:', message);
  }
};

const pushEvent = event => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
  logEventTrackingInfo(event);
};

const trackEvent = event => {
  if (!event) return;
  Array.isArray(event) ? event.forEach(pushEvent) : pushEvent(event);
};

const eventTracker = store => next => action => {
  try {
    if (action.type in analyticsEvents) {
      const events = getTrackerEvents(store.getState(), action);
      events?.forEach(trackEvent);
    }
  } catch (err) {
    logEventTrackingInfo(err);
  }
  return next(action);
};

export default eventTracker;
